<div class="table-container" *ngIf="clienteID">
    <div id="mainDiv">
        <p-dropdown [options]="tipoDeTransacao" [(ngModel)]="transacaoSelecionada" optionLabel="label"
            placeholder="Tipo Transação" />
        <div class="p-iconField">
            <p-iconField iconPosition="right">
                <p-inputIcon class="icon-search-button" styleClass=" pi pi-search" (click)="search()" />
                <input class="input-field" [(ngModel)]="searchCodigo" (keydown)="onKeyDown($event)" type="text"
                    pInputText placeholder="Pesquisar pelo codigo do movimento" />
            </p-iconField>
        </div>

        <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
            placeholder="Pesquisar por data" />
        <p-button styleClass="button-adicionar-x" label="Buscar" icon="pi pi-search" (click)="search()" />
    </div>
    <p-table [value]="movimentacao" class="table-style" [customSort]="true" (sortFunction)="customSort($event)">
        <ng-template class="ct-tr" pTemplate="header">
            <tr>
                <th pSortableColumn="id"># <p-sortIcon field="id" /> </th>
                <th pSortableColumn="codigoMovimento">Codigo Movimento <p-sortIcon field="codigoMovimento" /> </th>
                <th pSortableColumn="tipoDeTransacao">Tipo Transação <p-sortIcon field="tipoDeTransacao" /> </th>
                <th pSortableColumn="valor">Valor Total <p-sortIcon field="valor" /> </th>
                <th>Moeda Da Conta </th>
                <th>moedaDaContaDestino </th>
                <th pSortableColumn="criadoEm">Data da inclusão <p-sortIcon field="criadoEm" /> </th>
                <th>Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-movimentacao>
            <tr>
                <td>{{ movimentacao.id }}</td>
                <td>{{ movimentacao.codigoMovimento }}</td>
                <td>{{ traduzirTipoTransacao(movimentacao.tipoDeTransacao) }}</td>
                <td>{{ movimentacao.valor }}</td>
                <td>{{ movimentacao.moedaDaConta }}</td>
                <td>{{ movimentacao.moedaDaContaDestino }}</td>
                <td>{{ movimentacao.criadoEm }}</td>
                <td>
                    <div class="table-actions">
                        <i class="pi pi-eye pi-download" pTooltip="Relatorio pdf" tooltipPosition="top"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="pagination-container">
        <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>

        <span class="mx-1 text-color">Itens por página: </span>
        <p-dropdown [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()"></p-dropdown>
    </div>
</div>
